<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>
      <div class="margin-top-home">
        <b-row cols="1" cols-sm="1" cols-md="3" cols-lg="3" cols-xl="3">
          <b-col v-if="club.owner" class="text-center margin-top-bottom">
            Club owner 
            <br>
            <router-link class="text-black" :to="{ name: 'Rider', params: { id: club.owner.id }}">
              <b>{{ club.owner.stravaDetails.firstname }} {{ club.owner.stravaDetails.lastname }}</b>
              &nbsp;<b-badge pill variant="primary">{{ club.owner.level }}</b-badge>
              <br>
              <img v-if="club.owner.stravaDetails.profile" :src="club.owner.stravaDetails.profile" width="50px">
              <img v-else src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="50px">
            </router-link>
          </b-col>
          <b-col class="margin-top-bottom text-center">
            <div class="inline">
              <h2>{{ club.name }}</h2>
              <div v-if="club.isPrivate" class="text-center">
                <span><b>Private club</b></span>
              </div>
              <div v-else class="text-center">
                <span><b>Public club</b></span>
              </div>
              <br>
              <span>{{ club.description }}</span>
            </div>
          </b-col>
          <b-col class="text-center margin-top-bottom">
            <div v-if="!isUserRegisteredOnClub" class="center-align">
              <div>
                <c-button :onClick="onRegister" variant="primary">Join now</c-button>
                <br>
                <span class="success">{{ registerSuccess }}</span>
                <span class="failure">{{ registerFailure }}</span>
              </div>
            </div>
            <div v-else class="center-align">
              You are a member of the club
            </div>
            <br>
            <div>
              Share club:
              <a><fa-icon :icon="['far', 'copy']" @click="copyToClipboard(clubLink)"/></a>
            </div>
          </b-col>
        </b-row>
        <br>
        <span class="failure">{{ failureMessage }}</span>
        <b-row cols="1" cols-sm="2" cols-md="4" cols-lg="4" cols-xl="4" class="text-center">
          <b-col>
            <b>Members:</b> {{ club.riders }}
          </b-col>
          <b-col>
            <b>Trophies created:</b> {{ club.trophies }}
          </b-col>
          <b-col>
            <b>Country:</b> {{ club.country }}
          </b-col>
          <b-col>
            <b>Created on:</b> {{ club.createdAt | date }}
          </b-col>
        </b-row>
        <div v-if="club && club.owner && club.owner.id === user.id" class="center-align margin-top-30">
          <c-button :onClick="onCreateTrophy" variant="primary">Create new trophy</c-button>
          &nbsp;
          <c-button :onClick="onSendEmail" variant="primary">
            Send email to club members
          </c-button>
        </div>
      </div>
      <div class="text-center margin-top-50">
        <div class="inline">
          <img src="../../public/trophyseries.png" width="120px">
          <span class="bigger-font-x2"> Current trophies</span>
          &nbsp;
          <img src="../../public/trophy.png" width="30px">
        </div>
        <br>
        <div v-if="comingTrophies.length === 0">No trophy</div>
        <br>
        <b-row cols="1" cols-sm="2" cols-md="4" cols-lg="4" cols-xl="4">
          <b-col 
            v-for="trophy in comingTrophies"
            :key="trophy.id"
            class="margin-top-bottom"
          >
              <router-link class="text-black text-decoration-none" :to="{ name: 'Trophy', params: { id: trophy.id }}">
                <b-card>
                  <b-card-text>
                    <img src="../../public/trophy.png" width="30px">&nbsp;
                    <h5 class="inline">{{ trophy.name }}</h5>
                    <br>
                    <br>
                    <b-row cols="2" cols-sm="2" cols-md="2" cols-lg="2" cols-xl="2">
                      <b-col>
                        <b>Participants:</b> {{ trophy.riders }}
                        <br><br>
                        <b>Start date:</b> {{ trophy.startDate | date }}
                      </b-col>
                      <b-col>
                        <b>Races:</b> {{ trophy.races }}
                        <br><br>
                        <b>End date:</b> {{ trophy.endDate | date }}
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-card>
              </router-link>
            </b-col>
          </b-row>
          <div class="center-align">
            <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'getTrophiesFromClub', 'comingTrophiesPagination')"/>
            Page: {{ comingTrophiesPagination.page }} / {{ comingTrophiesPagination.totalPages }}
            <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'getTrophiesFromClub', 'comingTrophiesPagination')"/>
          </div>
      </div>

      <div class="margin-top-50">
        <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
          <b-col>
            <div class="text-center">
              <h4 class="inline">Ranking</h4>
              &nbsp;&nbsp;(Total riders: {{ usersOnClubPagination.count }})
              <select v-model="selectedYear" @change="getClubRanking($event)" name="years" id="years">
                <option 
                  v-for="year in yearsToDisplayInDropdown"
                  :key="year"
                  :value="year"
                >
                  {{ year }}
                </option>
              </select>
            </div>
            <b-table :fields="fields" :items="usersOnClub" responsive="sm">
              <template #cell(rank)="data">
                <b>{{ data.item.rank }}</b>
              </template>

              <template #cell(rider)="data">
                <router-link class="text-black" :to="{ name: 'Rider', params: { id: data.item.user.id }}">
                  <img v-if="data.item.user.stravaDetails.profile" :src="data.item.user.stravaDetails.profile" width="25px">
                  <img v-else src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="25px">
                  <b class="margin-left">{{ data.item.user.stravaDetails.firstname }} {{ data.item.user.stravaDetails.lastname }}</b>
                </router-link>
                &nbsp;<b-badge pill variant="primary">{{ data.item.user.level }}</b-badge>
              </template>

              <template #cell(points)="data">
                <b>{{ data.item.points }}</b>
              </template>
            </b-table>
            <div class="center-align">
              <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'getClubRanking', 'usersOnClubPagination')"/>
              Page: {{ usersOnClubPagination.page }} / {{ usersOnClubPagination.totalPages }}
              <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'getClubRanking', 'usersOnClubPagination')"/>
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="text-center margin-top-50">
        <div class="inline">
          <img src="../../public/trophyseries.png" width="120px">
          <span class="bigger-font-x2"> Past trophies</span>
          &nbsp;
          <img src="../../public/trophy.png" width="30px">
        </div>
        <br>
        <div v-if="pastTrophies.length === 0">No trophy</div>
        <br>
        <b-row cols="1" cols-sm="2" cols-md="4" cols-lg="4" cols-xl="4">
          <b-col 
            v-for="trophy in pastTrophies"
            :key="trophy.id"
            class="margin-top-bottom"
          >
              <router-link class="text-black text-decoration-none" :to="{ name: 'Trophy', params: { id: trophy.id }}">
                <b-card>
                  <b-card-text>
                    <img src="../../public/trophy.png" width="30px">&nbsp;
                    <h5 class="inline">{{ trophy.name }}</h5>
                    <br>
                    <br>
                    <b-row cols="2" cols-sm="2" cols-md="2" cols-lg="2" cols-xl="2">
                      <b-col>
                        <b>Participants:</b> {{ trophy.riders }}
                        <br><br>
                        <b>Start date:</b> {{ trophy.startDate | date }}
                      </b-col>
                      <b-col>
                        <b>Races:</b> {{ trophy.races }}
                        <br><br>
                        <b>End date:</b> {{ trophy.endDate | date }}
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-card>
              </router-link>
            </b-col>
          </b-row>
          <div class="center-align">
            <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'getTrophiesFromClub', 'pastTrophiesPagination')"/>
            Page: {{ pastTrophiesPagination.page }} / {{ pastTrophiesPagination.totalPages }}
            <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'getTrophiesFromClub', 'pastTrophiesPagination')"/>
          </div>
      </div>

    </b-col>
  </b-row>
</template>

<script>

  import CButton from '@/components/Button'
  import { PaginationModule } from '../utils.js'

  export default {
    name: 'Club',
    components: { CButton },
    props: {
      id: String
    },
    data() {
      return {
        failureMessage: '',
        club: {},
        registerSuccess: '',
        registerFailure: '',
        isUserRegisteredOnClub: false,
        usersOnClub: [],
        fields: [
          {
            key: 'rank'
          },
          {
            key: 'rider'
          },
          {
            key: 'points',
            label: 'Club Points'
          }
        ],
        usersOnClubPagination: {
          page: 1,
          itemsPerPage: 10,
          count: null,
          totalPages: null
        },
        comingTrophies: [],
        comingTrophiesPagination: {
          page: 1,
          itemsPerPage: 4,
          count: null,
          totalPages: null
        },
        pastTrophies: [],
        pastTrophiesPagination: {
          page: 1,
          itemsPerPage: 4,
          count: null,
          totalPages: null
        },
        selectedYear: this.currentYear()
      }
    },
    async created() {
      if (this.$router.currentRoute.meta.requiresAuth && (!this.$store.state.loggedUser || !this.$store.state.loggedUser.email)) this.$router.push({name: 'SignUp'})

      await this.getClub()
      if (this.user && this.user.email) await this.getUserOnClub()
      await this.getClubRanking()
      await this.getTrophiesFromClub({ pastTrophies: false })
      await this.getTrophiesFromClub({ pastTrophies: true })
    },
    mounted() {

    },
    filters: {

    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
      yearsToDisplayInDropdown() {
        const startYear = 2023
        const years = ['All']

        for (let i=startYear; i <= this.currentYear(); i++) {
          years.push(i)
        }

        return years
      },
      clubLink() {
        return `${process.env.VUE_APP_FRONT_URL}/club/${this.id}`
      }
    },
    methods: {
      async getClub() {
        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getClub.graphql'),
          variables: {
            id: this.id
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getClub) {
          this.club = Object.assign({}, this.club, result.data.getClub)
        }
      },
      async getUserOnClub() {
        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'private',
          query: require('@/graphql/getUserOnClub.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            clubId: this.id
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getUserOnClub) {
          if (result.data.getUserOnClub.id) {
            this.isUserRegisteredOnClub = true
          }
        }
      },
      async onRegister(event) {
        if (!this.user || !this.user.email) this.$router.push({ name: 'SignUp' });

        this.registerSuccess = ''
        this.registerFailure = ''

        const result = await this.$apollo.mutate({
          client: 'private',
          mutation: require('@/graphql/addUserToClub.graphql'),
          variables: {
            clubId: this.id
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.registerFailure = e.body.message;
            }
          }
        } else {
          this.registerSuccess = "You are now a member of this club";

          await this.getUserOnClub()
          await this.getClubRanking()
        }
      },
      async onCreateTrophy(event) {
        this.$router.push({ name: 'CreateTrophy', params: { id: this.id }});
      },
      async onSendEmail(event) {
        this.$router.push({ name: 'SendEmail', params: { id: this.id }});
      },
      async getClubRanking() {
        this.usersOnClub = []

        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getClubRanking.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            clubId: this.id,
            year: this.selectedYear === 'All' ? undefined : this.selectedYear,
            page: this.usersOnClubPagination.page,
            itemsPerPage: this.usersOnClubPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getClubRanking) {
          this.usersOnClub.push(...result.data.getClubRanking.usersClub)
          this.usersOnClubPagination.count = result.data.getClubRanking.pagination.count
          this.usersOnClubPagination.totalPages = result.data.getClubRanking.pagination.totalPages

          const userIdToCheck = this.userId ? this.userId : this.user ? this.user.id : undefined
          if (userIdToCheck) {
            for (let i=0; i < this.usersOnClub.length; i++) {
              const rank = this.usersOnClub[i];
              if (rank.user.id === userIdToCheck) rank._rowVariant = 'primary'
            }
          }
        }
      },
      async getTrophiesFromClub({ pastTrophies = false }) {
        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getTrophiesFromClub.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            clubId: this.id,
            pastTrophies,
            page: pastTrophies ? this.pastTrophiesPagination.page : this.comingTrophiesPagination.page,
            itemsPerPage: pastTrophies ? this.pastTrophiesPagination.itemsPerPage : this.comingTrophiesPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getTrophiesFromClub) {
          if (pastTrophies) {
            this.pastTrophies = result.data.getTrophiesFromClub.trophies
            this.pastTrophiesPagination.count = result.data.getTrophiesFromClub.pagination.count
            this.pastTrophiesPagination.totalPages = result.data.getTrophiesFromClub.pagination.totalPages
          } else {
            this.comingTrophies = result.data.getTrophiesFromClub.trophies
            this.comingTrophiesPagination.count = result.data.getTrophiesFromClub.pagination.count
            this.comingTrophiesPagination.totalPages = result.data.getTrophiesFromClub.pagination.totalPages
          }
        }
      },
      pagination(type, funcToExecute, obj) {
        const paginationModule = PaginationModule();
        const newPage = paginationModule.changePage(type, this[obj].page, this[obj].totalPages);
        if (newPage) {
          this[obj].page = newPage;
          this[funcToExecute](this[obj].payload);
        }
      },
      currentYear() {
        const now = new Date()
        const currentYear = now.getFullYear()
        return currentYear
      },
      copyToClipboard(val) {
        this.$copyText(val).then(function () {
          alert('Copied')
        }, function () {
          alert("Couldn't copy to clipboard")
        })
      },
    }
  }
</script>

<style scoped>

</style>
